

const Index = () => {
    return <div className='text-center page' style={{ padding: '100px 0', fontSize: '20px' }}>
        This Page Is Not Found
    </div>
}

export default Index;